export const DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE = 'DD.MM.YYYY HH:mm'